export const JUST_NOW = "Just now";
export const TODAY = "Today";
export const YESTERDAY = "Yesterday";
export const DAYS_AGO = "days ago";
export const WEEK_AGO = "1 week ago";
export const WEEKS_AGO = "weeks ago";
export const YEAR_AGO = "year ago";
export const YEARS_AGO = "years ago";
export const AM = "AM";
export const PM = "PM";
export const AM_REPLACEMENT = "a.m.";
export const PM_REPLACEMENT = "p.m.";